<template>
  <nuxt-link
    role="button"
    class="back-btn"
    data-test="pitch-type-detail-close"
    :to="{ query: { ...$route.query, pitchtype: undefined }, force: true }"
  >
    <img
      class="nav-icon"
      src="@/assets/images/forward-rounded-dark-blue.svg"
      width="17"
      height="30"
      alt=""
    />
    <translate class="sr-only"> Back </translate>
  </nuxt-link>
</template>

<script lang="ts">
import { Component, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class PitchtypeDetailClose extends Vue {}

export default toNative(PitchtypeDetailClose)
</script>

<style scoped>
.back-btn {
  height: 2em;
  width: 0.9em;
  margin: 0.5em 0.9em 0 0;
  flex: 0 0 auto;
}

img {
  transform: rotate(180deg);
}
</style>
